import React from 'react';

import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';

import Discern from '@views/Discern/Main';

export default function DiscernPage() {
  return (
    <RoleGuard roles={[RoleName.Admin, RoleName.Curator]}>
      <Discern />
    </RoleGuard>
  );
}
